import styled from 'styled-components';

export const Wrapper = styled.section`
  max-width: var(--maxWidth);
  margin: 0 auto;
  padding: 72px var(--gutter) 0;

  .more {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
`;

export const Header = styled.div`
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 2px solid var(--ink);

  span {
    display: block;
    margin-bottom: 8px;
    font-family: var(--font-mono);
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--accent);
  }

  h2 {
    font-size: clamp(34px, 5vw, 56px);
    font-weight: 800;
    letter-spacing: -0.035em;

    em {
      font-weight: 400;
      color: var(--muted);
    }
  }
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Person = styled.li`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--surface);
  animation: fadeUp 0.5s var(--ease) both;
  transition: border-color 0.2s, transform 0.3s var(--ease);

  &:hover {
    border-color: var(--ink);
    transform: translateY(-2px);
  }

  img,
  .fallback {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center 20%;
    background: var(--surface-2);
  }

  .fallback {
    display: grid;
    place-items: center;
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 800;
    font-size: 22px;
    color: var(--accent);
  }

  div {
    min-width: 0;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.01em;
    line-height: 1.2;
  }

  p {
    margin-top: 3px;
    font-size: 14px;
    color: var(--muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
